import { getEnv } from '@src/apis/shared';
import { getApiToken } from '@src/apis/reware/utils/tokenExchange';
import {
  ConfigsApi,
  Configuration,
} from '@troverecommerce/ps-configs-api-client';

export const getConfigsApiClient = async () => {
  const token = await getApiToken();

  const config = new Configuration({
    basePath: getEnv('CONFIG_API_BASE'),
    apiKey: token,
  });

  return new ConfigsApi(config);
};